export default __webpack_public_path__ + "static/media/how_to_1.40f0868e.jpg";